module.exports = __webpack_public_path__ + "static/media/jnt.e55f8ae8.svg";